import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"
export default class extends Controller {
  connect() {}

  performance() {}
}
